<template>
  <!-- 中国地图散点图 -->
  <div :id="chinaChartInfo.nodeId"></div>
</template>

<script>
export default {
  name: "ChinaChart1",
  props:["chinaChartInfo"],
  data(){
    return {
      // chinaChartInfo:{
      //     nodeId:'ageDistribution',//节点
      //     data: [
        // {name:'上海',value:90},
        // {name:'武汉',value: 273 },
        // { name: '德州', value: 120 },
        // { name: '成都', value: 58 },
    //   ],//数据
          // text:[]
      // }
    }
  },
  computed:{
    
  },
  methods:{
    chinaChart(chinaChartInfo){
    this.$echarts.dispose(document.getElementById(chinaChartInfo.nodeId));
    var myChart = this.$echarts.init(document.getElementById(chinaChartInfo.nodeId));
    myChart.setOption({
    tooltip : {
        trigger: 'item',
        formatter: function (val) {
          let vals = val.value;
          if (isNaN(vals)) {
            vals = 0;
          }
          return val.name+ " : "+ vals+"%";
        }
    },
    legend: {
        orient: 'vertical',
        left: 'left',
        data:['iphone']
    },
    visualMap: {
        min: 0,
        max: 13,
        left:'6%',
        bottom:'6%',
        itemWidth:12,
        itemHeight:84,
        calculable:false,
        inRange:{
        color: [
          "#eaf7ff",
          "#c0e7ff",
          "#74caff",
          "#009fff",
          "#16abff",
          "#008cff",
          "#007fff",
          "#1564ec",
        ], // 图元的颜色
        // color: [
        //       "#d5ecff",
        //       "#c5e4ff",
        //       "#b2dbff",
        //       "#90cbff",
        //       "#8cc9ff",
        //       "#77bfff",
        //       "#53aeff",
        //       "#38a1ff",
        //     ], // 图元的颜色
        },
        // textStyle:{
        //     color:'#fff'
        // },
        // text:[],           // 文本，默认为数值文本
        text:chinaChartInfo.text?chinaChartInfo.text:[],           // 文本，默认为数值文本
    },
    series : [
        {
            name: '省份',
            type: 'map',
            mapType: 'china',
            roam: false,
            label: {
                normal: {
                    show: false
                },
                emphasis: {
                    show: true
                }
            },
            itemStyle: {
                color:"transparent",//小红点
                areaColor: "#e0f1ff", // 地图区域的颜色 如果设置了visualMap，areaColor属性将不起作用
                borderWidth: 0.5, // 描边线宽 为 0 时无描边
                borderColor: "#fff", // 图形的描边颜色 支持的颜色格式同 color，不支持回调函数
                borderType: "solid", // 描边类型，默认为实线，支持 'solid', 'dashed', 'dotted'
            },
            data:chinaChartInfo.data
        }
    ]
        }) 
    },
  },
  components:{
   
  },
  watch:{
    
  },
  mounted() {
    this.chinaChart(this.chinaChartInfo)
  }
}
</script>

<style scoped>
  

</style>